import { DateTime } from "luxon";
import { PatientBasicInformation, PatientInformation } from "../interfaces/patient.interface";

export const transform = {
    patient: (data: any[]) => transformPatient(data),
    tracking: {
      questions: (data: any[]) => transformTrackingQuestions(data),
    }
}

const transformPatient = (data: any[]) => {
  return data.map((patient) => {
    const basicInfo: PatientBasicInformation | null = patient.patient_basic_information?.[0] || null;
    const info: PatientInformation | null = patient.patient_information?.[0] || null;
    const appointments = patient.appointment;
    let next_appointment = null;
    if(appointments.length){
      const currentDate = DateTime.now().minus({days: 2});
      const filter = appointments
      .filter((appointment: any) => 
        DateTime.fromISO(appointment.date) > currentDate
      )
      .sort((a: any, b: any) => {
        const getStatusPriority = (status: string) => {
          if (status === 'pending') return 1;
          if (status === 'accepted') return 2;
          if (status === 'done') return 3;
          if (status === 'no_show') return 3;
          return 3;
        };
      
        const statusPriorityA = getStatusPriority(a.status);
        const statusPriorityB = getStatusPriority(b.status);
      
        if (statusPriorityA !== statusPriorityB) {
          return statusPriorityA - statusPriorityB;
        };  
        
        return DateTime.fromISO(b.date).toMillis() - DateTime.fromISO(a.date).toMillis();
      });

      next_appointment = filter[0];
    }


    return {
      id: patient.id,
      therapist: patient.therapist,
      account: patient.account,
      patient_basic_information: basicInfo,
      patient_information: info,
      email: patient.email,
      appointments,
      next_appointment,
    };
  });
}

const transformTrackingQuestions = (data: any[]) => {
  const dataTransform = data.map((question) => {
    const questions: any[] = question?.emotional_tracking?.emotional_tracking_question || [];
  
    return questions;
  });

  const questionArr = dataTransform.filter((q) => q.length);

  const questionPerDay: any = {};

    questionArr.forEach((arrQ: any) => {
        arrQ.forEach((q: any) => {
            const date = DateTime.fromISO(q.created_at).toISODate() || DateTime.now().toISODate();
            const mood = q.default_emotional_tracking_questions.mood;
            
            if (!questionPerDay[date]) {
                questionPerDay[date] = {};
            }

            if (!questionPerDay[date][mood]) {
                questionPerDay[date][mood] = [];
            }
            
            questionPerDay[date][mood].push(q);
        });
    });

    const result = Object.entries(questionPerDay).map(([date, moodObj]: any) => {
        return {
            date,
            moods: Object.entries(moodObj).map(([mood, questions]) => {
                return { mood, questions };
            })
        };
    });

    result.sort((a, b) => DateTime.fromISO(a.date).toMillis() - DateTime.fromISO(b.date).toMillis());

    return result;
}